
import ig from "./ig.png"

const InstagramIcon = () => {
  return (
    <img
      src={ig}
      width="40"
      height="40"
      viewBox="0 0 80 80"
      fill="none"
      
    >
      
    </img>
  )
}

export default InstagramIcon
